import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "./site";

const TOKEN_KEY = "ascendance_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

// Axios instance that always attaches the admin token
export const authApi = axios.create({ baseURL: API });
authApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  const [checking, setChecking] = useState(true);

  const loadMe = useCallback(async () => {
    if (!getToken()) {
      setUser(false);
      setChecking(false);
      return;
    }
    try {
      const { data } = await authApi.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
